import { BaseSerializer } from '@/app/core/serializers/baseSerializer';

class AdminSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success = serverRes.statusCode == 200 || serverRes.statusCode == 201 || serverRes.statusCode == 404;

    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message: serverRes.message || 'Erreur',
        data: null
      };
    }

    const admins = serverRes?.data || [];
    const deserialized = admins.map(admin => ({
      id: admin.id || admin._id,
      firstName: admin.firstName || '',
      lastName: admin.lastName || '',
      email: admin.email || '',
      phoneNumber: admin.phoneNumber || '',
      country: admin.country || 'BJ',
      metadata: admin.metadata || {},
      createdAt: admin.createdAt,
      updatedAt: admin.updatedAt
    }));

    return {
      statusCode: 200,
      success: true,
      message: 'Admins retrieved',
      data: deserialized
    };
  }

  deserializeSingle(raw) {
    const success = raw?.statusCode == 200 || raw?.statusCode == 201;

    const errorTexts = success
      ? null
      : errorMessages[`${raw?.statusCode}`] || errorMessages.other;

    return {
      success,
      statusCode: raw?.statusCode || 500,
      message: success ? 'ok' : errorTexts?.message,
      errorTitle: errorTexts?.title
    };
  }

  serializeRegister(adminData) {
    return {
      firstName: adminData.firstName,
      lastName: adminData.lastName,
      email: adminData.email,
      phoneNumber: '22900000000',
      // phonePrefix: '229',
      countryCode: 'BJ',
      password: adminData.password,
      metadata: {
        features: adminData.features || [],
        countries: adminData.countries || []
      }
    };
  }

  serializeUpdate(adminData) {
    return {
      id: adminData.id,
      firstName: adminData.firstName,
      lastName: adminData.lastName,
      metadata: {
        features: adminData.features || [],
        countries: adminData.countries || []
      }
    };
  }

  serializeDelete(adminId) {
    return {
      id: adminId
    };
  }
}

const errorMessages = {
  409: {
    title: 'Email déjà utilisé',
    message: 'Cet email est déjà associé à un compte. Veuillez en utiliser un autre.'
  },
  400: {
    title: 'Erreur dans les données',
    message: 'Les informations soumises sont invalides. Veuillez vérifier et réessayer.'
  },
  401: {
    title: 'Non autorisé',
    message: "Vous n'êtes pas autorisé à effectuer cette opération."
  },
  404: {
    title: 'Administrateur introuvable',
    message: 'Aucun administrateur ne correspond à cet identifiant.'
  },
  other: {
    title: 'Erreur',
    message: 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
  }
};

export const serializer = new AdminSerializer();
